module.exports = __webpack_public_path__ + "img/lg_ring_r_0_0_0@2x.c47c2ce0.png";